(function (window, document, $) {
  'use strict';

  function waitForLoadAvailability() {
    if (typeof window.loadAvailability === 'function') {
      return Promise.resolve();
    }

    return new Promise(function (resolve) {
      var interval = setInterval(function () {
        if (typeof window.loadAvailability === 'function') {
          clearInterval(interval);
          resolve();
        }
      }, 50);
    });
  }

  function formatPrice(value) {
    if (typeof value !== 'number' || !isFinite(value)) {
      return '';
    }
    var fixed = value.toFixed(2);
    if (fixed.indexOf('.') !== -1) {
      fixed = fixed.replace(/\.00$/, '').replace(/(\.[0-9]*?)0+$/, '$1');
    }
    return fixed;
  }

  function isFiniteNumber(value) {
    return typeof value === 'number' && isFinite(value);
  }

  function normalizeTicketLabel(value, fallback) {
    if (typeof value === 'string') {
      var cleaned = value.trim();
      if (cleaned) {
        cleaned = cleaned.replace(/\s*\((?:ticket|tickets)\)\s*$/i, '').trim();
        cleaned = cleaned.replace(/\s*\b(?:ticket|tickets)\b\.?$/i, '').trim();
        if (cleaned) {
          return cleaned;
        }
      }
    }
    return typeof fallback === 'string' ? fallback : '';
  }

  function parseDomDiscount() {
    var domDiscount = null;
    try {
      var wasEl = document.querySelector('.prices .wasPrice');
      if (!wasEl) {
        return null;
      }
      var pricesContainer = wasEl.closest && wasEl.closest('.prices')
        ? wasEl.closest('.prices')
        : document.querySelector('.prices');
      var curEl = pricesContainer
        ? pricesContainer.querySelector('.currentPrice')
        : document.querySelector('.prices .currentPrice');
      if (!curEl) {
        return null;
      }
      var txt = (curEl.textContent || curEl.innerText || '').trim();
      txt = txt.replace(/[^0-9\.\-]/g, '');
      var parsed = parseFloat(txt);
      if (!isNaN(parsed)) {
        domDiscount = parsed;
      }
    } catch (e) {
      domDiscount = null;
    }
    return domDiscount;
  }

  function hasMarketplaceAvailability() {
    var availableDatesSet = window.$myAvailableDates;
    if (availableDatesSet && typeof availableDatesSet.size === 'number') {
      return availableDatesSet.size > 0;
    }
    if (Array.isArray(availableDatesSet)) {
      return availableDatesSet.length > 0;
    }
    return false;
  }

  function toggleElement(element, show) {
    if (!element) {
      return;
    }
    if (show) {
      element.classList.remove('hidden');
      element.style.display = '';
    } else {
      element.classList.add('hidden');
      element.style.display = 'none';
    }
  }

  function monitorAvailabilitySet(callback) {
    var availableDatesSet = window.$myAvailableDates;
    if (!availableDatesSet || typeof availableDatesSet.add !== 'function') {
      return;
    }

    if (!availableDatesSet.__marketplaceMonitor) {
      var callbacks = [];
      var originalAdd = availableDatesSet.add;
      var originalDelete = availableDatesSet.delete;
      var originalClear = availableDatesSet.clear;

      function triggerCallbacks() {
        callbacks.slice().forEach(function (cb) {
          try {
            cb();
          } catch (err) {
            var errorMessage = err && (err.message || (err.toString ? err.toString() : ''));
            logError(0, errorMessage || 'Unknown error', 'monitorAvailabilitySet callback', window.location.href);
            if (typeof console !== 'undefined' && console.error) {
              console.error(err);
            }
          }
        });
      }

      availableDatesSet.add = function () {
        var result = originalAdd.apply(this, arguments);
        triggerCallbacks();
        return result;
      };

      if (typeof originalDelete === 'function') {
        availableDatesSet.delete = function () {
          var result = originalDelete.apply(this, arguments);
          triggerCallbacks();
          return result;
        };
      }

      if (typeof originalClear === 'function') {
        availableDatesSet.clear = function () {
          var result = originalClear.apply(this, arguments);
          triggerCallbacks();
          return result;
        };
      }

      availableDatesSet.__marketplaceMonitor = true;
      availableDatesSet.__marketplaceCallbacks = callbacks;
    }

    if (typeof callback === 'function') {
      if (!Array.isArray(availableDatesSet.__marketplaceCallbacks)) {
        availableDatesSet.__marketplaceCallbacks = [];
      }
      availableDatesSet.__marketplaceCallbacks.push(callback);
    }
  }

  function updateInstantBookPrice(infoEl, priceEl) {
    var partCount = window.part || 1;
    if (!isFinite(partCount) || partCount < 1) {
      partCount = 1;
    }

    function buildMarketplacePerTicketText(data) {
      if (!data) {
        return '';
      }

      var perTicketLabel = normalizeTicketLabel(data.ticketLabel, '');
      if (!perTicketLabel) {
        perTicketLabel = normalizeTicketLabel(data.ticketType, '');
      }
      if (!perTicketLabel) {
        perTicketLabel = normalizeTicketLabel(data.label, 'ticket');
      }
      return perTicketLabel || 'ticket';

    }

    function buildStandardPerTicketText(data) {
      if (!data) {
        return '';
      }
      var coverage = data.seatCoverage || 1;

      if (data.ticketLabel && data.ticketLabel.trim()) {
        return normalizeTicketLabel(data.ticketLabel, coverage > 1 || partCount > 1 ? 'tickets' : 'ticket');
      }
      return coverage > 1 || partCount > 1 ? 'tickets' : 'ticket';

    }

    function buildMarketplaceOptionText(data) {
      if (!data) {
        return '';
      }
      if (data.ticketType && data.ticketType.trim()) {

        return normalizeTicketLabel(data.ticketType, 'ticket');
      }
      if (data.label && data.label.trim()) {
        return normalizeTicketLabel(data.label, 'ticket');
      }
      if (data.ticketLabel && data.ticketLabel.trim()) {
        return normalizeTicketLabel(data.ticketLabel, 'ticket');

      }
      return 'ticket';
    }

    function buildStandardOptionText(data) {
      if (!data) {
        return '';
      }
      var coverage = data.seatCoverage || 1;
      if (data.ticketLabel && data.ticketLabel.trim()) {
        return normalizeTicketLabel(data.ticketLabel, coverage > 1 ? 'tickets' : 'ticket');
      }
      return coverage > 1 ? 'tickets' : 'ticket';
    }

    var domDiscount = parseDomDiscount();
    var bestOption = null;
    var bestPerTicket = {
      price: Infinity,
      label: '',
      ticketType: '',
      ticketLabel: '',
      seatCoverage: 1,
      optionId: null
    };
    var highestPerTicket = {
      price: -Infinity,
      label: '',
      ticketType: '',
      ticketLabel: '',
      seatCoverage: 1,
      optionId: null
    };
    var highestOption = null;

    (window.availabilitySessions || []).forEach(function (sess) {
      (sess.priceOptions || []).forEach(function (opt) {
        var multiplier = parseFloat(opt.priceOptionMultiplier);
        if (!isFiniteNumber(multiplier) || multiplier <= 0) {
          multiplier = 1;
        }

        var basePriceRaw = parseFloat(opt.price);
        var basePerTicket = isFiniteNumber(basePriceRaw) ? basePriceRaw * multiplier : NaN;

        var discountedPerTicket = NaN;
        var discountedFromDOM = false;

        var optionDiscountRaw = parseFloat(opt.discountedPrice);
        if (isFiniteNumber(optionDiscountRaw)) {
          discountedPerTicket = optionDiscountRaw * multiplier;
        } else if (domDiscount !== null && isFiniteNumber(basePerTicket) && domDiscount < basePerTicket) {
          discountedPerTicket = domDiscount;
          discountedFromDOM = true;
        }

        if (!discountedFromDOM && isFiniteNumber(discountedPerTicket)) {
          // already normalized via multiplier above when sourced from option data
        }

        var seatCoverage = Math.max(
          1,
          (parseInt(opt.seatsUsed, 10) || 0),
          (parseInt(opt.priceOptionMultiplier, 10) || 0),
          (parseInt(opt.seatsPerTicket, 10) || 0)
        );

        var ticketsNeeded = Math.max(1, Math.ceil(partCount / seatCoverage));

        var totalBase = isFiniteNumber(basePerTicket) ? basePerTicket * ticketsNeeded : NaN;
        var totalDiscount = isFiniteNumber(discountedPerTicket)
          ? discountedPerTicket * ticketsNeeded
          : NaN;

        var useDiscount =
          isFiniteNumber(totalBase) &&
          totalBase > 0 &&
          isFiniteNumber(totalDiscount) &&
          totalDiscount > 0 &&
          totalDiscount < totalBase;

        var effectiveTotal;
        if (useDiscount) {
          effectiveTotal = totalDiscount;
        } else if (isFiniteNumber(totalBase) && totalBase > 0) {
          effectiveTotal = totalBase;
        } else if (isFiniteNumber(totalDiscount) && totalDiscount > 0) {
          effectiveTotal = totalDiscount;
          totalBase = NaN;
          useDiscount = false;
        } else {
          return;
        }

        if (!isFiniteNumber(effectiveTotal) || effectiveTotal <= 0) {
          return;
        }

        var ticketLabel = '';
        if (
          useDiscount &&
          opt.discountedTicketType &&
          opt.discountedTicketType.trim() !== '' &&
          opt.discountedTicketType !== 'Other'
        ) {
          ticketLabel = opt.discountedTicketType;
        } else if (opt.TicketType && opt.TicketType.trim() !== '' && opt.TicketType !== 'Other') {
          ticketLabel = opt.TicketType;
        } else if (opt.label) {
          ticketLabel = opt.label;
        }

        var displayPerTicket = isFiniteNumber(discountedPerTicket) ? discountedPerTicket : basePerTicket;
        if (isFiniteNumber(displayPerTicket) && displayPerTicket > 0 && displayPerTicket < bestPerTicket.price) {
          bestPerTicket.price = displayPerTicket;
          bestPerTicket.ticketType = (opt.TicketType && opt.TicketType.trim() && opt.TicketType !== 'Other') ? opt.TicketType : '';
          bestPerTicket.label = opt.label || '';
          bestPerTicket.ticketLabel = ticketLabel || '';
          bestPerTicket.seatCoverage = seatCoverage;
          bestPerTicket.optionId = opt.id || null;
        }

        if (isFiniteNumber(displayPerTicket) && displayPerTicket > highestPerTicket.price) {
          highestPerTicket.price = displayPerTicket;
          highestPerTicket.ticketType = (opt.TicketType && opt.TicketType.trim() && opt.TicketType !== 'Other') ? opt.TicketType : '';
          highestPerTicket.label = opt.label || '';
          highestPerTicket.ticketLabel = ticketLabel || '';
          highestPerTicket.seatCoverage = seatCoverage;
          highestPerTicket.optionId = opt.id || null;
        }

        if (!bestOption || effectiveTotal < bestOption.total) {
          bestOption = {
            total: effectiveTotal,
            totalBase: isFiniteNumber(totalBase) ? totalBase : null,
            useDiscount: useDiscount && isFiniteNumber(totalBase),
            seatCoverage: seatCoverage,
            ticketsNeeded: ticketsNeeded,
            ticketLabel: ticketLabel,
            optionId: opt.id || null,
            perTicketDisplay: (function () {
              var dpt = isFiniteNumber(discountedPerTicket) ? discountedPerTicket : basePerTicket;
              return isFiniteNumber(dpt) ? dpt : NaN;
            })(),
            ticketType: (opt.TicketType && opt.TicketType.trim()) ? opt.TicketType.trim() : '',
            label: opt.label || ''
          };
        }

        if (!highestOption || effectiveTotal > highestOption.total) {
          highestOption = {
            total: effectiveTotal,
            seatCoverage: seatCoverage,
            ticketLabel: ticketLabel,
            optionId: opt.id || null,
            ticketType: (opt.TicketType && opt.TicketType.trim()) ? opt.TicketType.trim() : '',
            label: opt.label || ''
          };
        }
      });
    });

    if (!bestOption) {
      return;
    }

    var instantBookEl = document.querySelector('.instantBook');
    var messageEl = document.getElementById('marketplace-no-availability');
    var isMarketplace = window.marketplace === true || document.querySelector('.badge-marketplace') !== null;
    var hasPerTicketPrice = isFiniteNumber(bestPerTicket.price) && bestPerTicket.price < Infinity;
    var useMinBookingFrom = isMarketplace && partCount > 1 && !hasPerTicketPrice;
    var lowest;
    var usingPerTicketPrice = false;
    if (useMinBookingFrom) {
      lowest = bestOption.total;
    } else if (hasPerTicketPrice) {
      lowest = bestPerTicket.price;
      usingPerTicketPrice = true;
    } else {
      lowest = bestOption.total;
    }
    var original = null;

    var ticketText = '';
    if (!useMinBookingFrom) {
      if (usingPerTicketPrice) {
        if (isMarketplace) {
          var perTicketLabel = normalizeTicketLabel(bestPerTicket.ticketLabel, '');
          if (!perTicketLabel) {
            perTicketLabel = normalizeTicketLabel(bestPerTicket.ticketType, '');
          }
          if (!perTicketLabel) {
            perTicketLabel = normalizeTicketLabel(bestPerTicket.label, 'ticket');
          }
          ticketText = perTicketLabel || 'ticket';
        } else {
          if (bestPerTicket.ticketLabel && bestPerTicket.ticketLabel.trim()) {
            ticketText = normalizeTicketLabel(
              bestPerTicket.ticketLabel,
              (bestPerTicket.seatCoverage > 1 || partCount > 1) ? 'tickets' : 'ticket'
            );
          } else {
            ticketText = (bestPerTicket.seatCoverage > 1 || partCount > 1) ? 'tickets' : 'ticket';
          }
        }
      } else if (isMarketplace) {
        if (bestPerTicket.ticketType && bestPerTicket.ticketType.trim()) {
          ticketText = normalizeTicketLabel(bestPerTicket.ticketType, 'ticket');
        } else if (bestPerTicket.label && bestPerTicket.label.trim()) {
          ticketText = normalizeTicketLabel(bestPerTicket.label, 'ticket');
        } else {
          ticketText = 'ticket';
        }
      } else {
        if (bestOption.ticketLabel && bestOption.ticketLabel.trim()) {
          ticketText = normalizeTicketLabel(
            bestOption.ticketLabel,
            bestOption.seatCoverage > 1 ? 'tickets' : 'ticket'
          );
        } else {
          ticketText = bestOption.seatCoverage > 1 ? 'tickets' : 'ticket';
        }
      }
    }

    var highestDisplayPrice = null;
    var highestTicketText = '';
    var priceDeltaEpsilon = 0.01;

    if (!useMinBookingFrom) {
      if (usingPerTicketPrice) {
        if (isFiniteNumber(highestPerTicket.price) && highestPerTicket.price > bestPerTicket.price + priceDeltaEpsilon) {
          highestDisplayPrice = highestPerTicket.price;
          highestTicketText = isMarketplace
            ? buildMarketplacePerTicketText(highestPerTicket)
            : buildStandardPerTicketText(highestPerTicket);
        }
      } else if (isMarketplace) {
        if (highestOption && highestOption.total > bestOption.total + priceDeltaEpsilon) {
          highestDisplayPrice = highestOption.total;
          highestTicketText = buildMarketplaceOptionText(highestOption);
        }
      } else {
        if (highestOption && highestOption.total > bestOption.total + priceDeltaEpsilon) {
          highestDisplayPrice = highestOption.total;
          highestTicketText = buildStandardOptionText(highestOption);
        }
      }
    }

    if (infoEl) {
      infoEl.textContent = '';
      infoEl.append('Instant booking ');
      var strongPrice = document.createElement('strong');
      var formattedLowest = formatPrice(lowest);
      strongPrice.textContent = 'from $' + formattedLowest;
      infoEl.appendChild(strongPrice);

      if (useMinBookingFrom) {
        var canShowPPHint = isFiniteNumber(bestOption.perTicketDisplay) &&
          Math.abs((bestOption.perTicketDisplay * partCount) - bestOption.total) < 0.01;

        if (canShowPPHint) {
          infoEl.append(' (');
          var strongPP = document.createElement('strong');
          strongPP.textContent = '$' + formatPrice(bestOption.perTicketDisplay) + ' pp ' +
            ((bestOption.ticketLabel && bestOption.ticketLabel.trim()) ? (bestOption.ticketLabel + ' ticket') : 'ticket');
          infoEl.appendChild(strongPP);
          infoEl.append(').');
        } else {
          infoEl.append('.');
        }
      } else {

        var strongTicket = document.createElement('strong');
        var cleanedTicketText = (ticketText || '').trim();
        if (cleanedTicketText && !/^tickets?$/i.test(cleanedTicketText)) {
          if (!/^\(.*\)$/.test(cleanedTicketText)) {
            cleanedTicketText = '(' + cleanedTicketText + ')';
          }
          infoEl.append(' ');
          strongTicket.textContent = cleanedTicketText;
          infoEl.appendChild(strongTicket);
        }

        if (isFiniteNumber(highestDisplayPrice) && highestDisplayPrice > 0) {
          infoEl.append(' to ');
          var strongHighPrice = document.createElement('strong');
          strongHighPrice.textContent = '$' + formatPrice(highestDisplayPrice);
          infoEl.appendChild(strongHighPrice);
          if (highestTicketText && highestTicketText.trim()) {
            var strongHighTicket = document.createElement('strong');
            var cleanedHighestTicket = highestTicketText.trim();
            if (!/^tickets?$/i.test(cleanedHighestTicket)) {
              if (!/^\(.*\)$/.test(cleanedHighestTicket)) {
                cleanedHighestTicket = '(' + cleanedHighestTicket + ')';
              }
              infoEl.append(' ');
              strongHighTicket.textContent = cleanedHighestTicket;
              infoEl.appendChild(strongHighTicket);
            }

          }
          infoEl.append('.');
        } else {
          infoEl.append('.');
        }
      }

      infoEl.appendChild(document.createElement('br'));
      infoEl.append('Final price depends on your ticket type and date.');
    }

    if (priceEl) {
      priceEl.textContent = '';
      var fromSpan = document.createElement('span');
      fromSpan.className = 'text-small text-lowercase text-muted';
      fromSpan.style.verticalAlign = 'middle';
      fromSpan.style.marginRight = '-6px';
      fromSpan.textContent = 'from';
      priceEl.appendChild(fromSpan);
      priceEl.append(' ');
      if (original !== null && isFiniteNumber(original) && original > lowest) {
        var formattedOriginal = formatPrice(original);
        var s = document.createElement('s');
        s.textContent = '$' + formattedOriginal;
        priceEl.appendChild(s);
        priceEl.append(' $' + formattedLowest);
      } else {
        priceEl.append('$' + formattedLowest);
      }
    }

    var instantBookEl = document.querySelector('.instantBook');
    var messageEl = document.getElementById('marketplace-no-availability');
    if (hasMarketplaceAvailability()) {
      toggleElement(messageEl, false);
      toggleElement(instantBookEl, true);
    } else {
      toggleElement(instantBookEl, false);
      toggleElement(messageEl, true);
    }
  }

  function initInstantBookingSummary() {
    var infoEl = document.getElementById('instant-book-info');
    if (!infoEl) {
      return;
    }
    var priceEl = document.querySelector('.instantBook .currentPrice');

    monitorAvailabilitySet(function () {
      var instantBookEl = document.querySelector('.instantBook');
      var messageEl = document.getElementById('marketplace-no-availability');
      if (!messageEl) {
        return;
      }
      var isMarketplace = window.marketplace === true || document.querySelector('.badge-marketplace') !== null;
      if (!isMarketplace) {
        return;
      }
      if (hasMarketplaceAvailability()) {
        toggleElement(messageEl, false);
        toggleElement(instantBookEl, true);
      } else {
        toggleElement(instantBookEl, false);
        toggleElement(messageEl, true);
      }
    });

    waitForLoadAvailability().then(function () {
      var promise = window.loadAvailabilityPromise;
      var now = Date.now();
      if (!promise || !window.loadAvailabilityPromiseExpiry || now > window.loadAvailabilityPromiseExpiry) {
        promise = window.loadAvailability();
        var expiry = now + 5 * 60 * 1000;
        window.loadAvailabilityPromise = promise;
        window.loadAvailabilityPromiseExpiry = expiry;
        setTimeout(function () {
          if (window.loadAvailabilityPromiseExpiry === expiry) {
            window.loadAvailabilityPromise = null;
            window.loadAvailabilityPromiseExpiry = 0;
          }
        }, 5 * 60 * 1000);
      }
      promise.then(function () {
        monitorAvailabilitySet(function () {
          updateInstantBookPrice(infoEl, priceEl);
        });
        updateInstantBookPrice(infoEl, priceEl);
      }).catch(function () {
        var instantBookEl = document.querySelector('.instantBook');
        var messageEl = document.getElementById('marketplace-no-availability');
        toggleElement(instantBookEl, false);
        toggleElement(messageEl, true);
      });
    });
  }

  function ensureInstantBookDataAttributes() {
    if (!$ || !$.fn || !$.fn.data) {
      return;
    }
    $('.iBook').data('tk', { iBtpid: window.pID, iBtType: window.tickType });
  }

  function loadModalStylesheet(url) {
    if (document.querySelector('link[href="' + url + '"]')) {
      return;
    }
    var link = document.createElement('link');
    link.href = url;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    document.head.appendChild(link);
  }

  var modalScriptPromises = {};
  var modalLaunchPromise = null;

  function loadModalScript(url, globalName) {
    if (globalName && window[globalName]) return Promise.resolve();
    if (modalScriptPromises[url]) return modalScriptPromises[url];
    var promise = new Promise(function (resolve, reject) {
      var script = document.querySelector('script[src="' + url + '"]');
      var created = !script;
      if (!script) {
        script = document.createElement('script');
        script.src = url;
        script.defer = true;
      }
      var timer = setTimeout(function () { finish(new Error('Timed out loading ' + url)); }, 15000);
      function finish(error) {
        clearTimeout(timer);
        script.removeEventListener('load', loaded);
        script.removeEventListener('error', failed);
        if (error) {
          if (created) script.remove();
          reject(error);
        } else {
          script.dataset.instantBookLoaded = 'true';
          resolve();
        }
      }
      function loaded() { finish(); }
      function failed() { finish(new Error('Failed to load ' + url)); }
      script.addEventListener('load', loaded);
      script.addEventListener('error', failed);
      if (script.dataset.instantBookLoaded === 'true') finish();
      else if (created) document.head.appendChild(script);
    });
    modalScriptPromises[url] = promise.catch(function (error) {
      delete modalScriptPromises[url];
      throw error;
    });
    return modalScriptPromises[url];
  }

  function requireModalGlobal(name) {
    if (!window[name]) throw new Error('Booking dependency did not initialise: ' + name);
  }

  function logError(errorNo, errorDescp, errorSource, referrer) {
    if (!$ || !$.ajax) {
      return;
    }
    $.ajax({
      url: '/inc/api/logerror.aspx',
      type: 'POST',
      data: {
        errorNo: errorNo,
        errorDescp: errorDescp,
        errorSource: errorSource,
        referrer: referrer || window.location.href
      }
    });
  }

  // Previously supplied by the Classic ASP footer; keep this available to the calendar too.
  window.slideInstantBookSession = window.slideInstantBookSession || function () {
    return fetch('/inc/api/slidesession', {
      method: 'POST', cache: 'no-store', credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).catch(function () {});
  };

  function launchInstantBookModal() {
    if (modalLaunchPromise) return modalLaunchPromise;
    var buttons = Array.prototype.slice.call(document.querySelectorAll('.iBook'));
    var previous = buttons.map(function (button) { return { html: button.innerHTML, disabled: button.disabled }; });
    buttons.forEach(function (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Loading booking…';
    });
    loadModalStylesheet(window.ASSETS_CSS['instantbookmodal']);

    modalLaunchPromise = Promise.resolve().then(function () { return slideInstantBookSession(); })
      .then(function () { return (typeof window.loadMapboxAssets === 'function' ? window.loadMapboxAssets() : Promise.resolve()); })
      .then(function () { return loadModalScript('https://unpkg.com/vue@3/dist/vue.global.prod.js', 'Vue'); })
      .then(function () { requireModalGlobal('Vue'); })
      .then(function () { return loadModalScript('https://unpkg.com/vue-router@4', 'VueRouter'); })
      .then(function () { requireModalGlobal('VueRouter'); })
      .then(function () { return loadModalScript('https://content.thrillexperiences.com.au/js/naive-ui@2.41.0.min.js', 'naive'); })
      .then(function () { requireModalGlobal('naive'); })
      .then(function () { return loadModalScript('https://cdn.jsdelivr.net/npm/swiper@11.2.6/swiper-bundle.min.js', 'Swiper'); })
      .then(function () { return loadModalScript(window.INSTANTBOOKMODAL_JS, 'createVueApp'); })
      .then(function () {
        return new Promise(function (resolve) { setTimeout(resolve, 100); });
      })
      .then(function () {
        if (typeof window.createVueApp === 'function') {
          var vueRoot = document.querySelector('#vue-app');
          if (vueRoot && vueRoot.__vue_app__ && typeof window.destroyVueApp === 'function') {
            window.destroyVueApp();
          }
          window.createVueApp();
        }

        requireModalGlobal('openInstantBookModal');
        window.openInstantBookModal();
      })
      .catch(function (err) {
        alert("We could not load booking. Please try Choose Tickets again.");
        logError(
          0,
          (err && (err.status || err.code)) ? (err.status || err.code) : 0,
          'Failed to load the Instant Book modal script: ' + (err && (err.message || (err.toString ? err.toString() : JSON.stringify(err)))),
          window.location.href
        );
      }).finally(function () {
        modalLaunchPromise = null;
        buttons.forEach(function (button, index) {
          button.innerHTML = previous[index].html;
          button.disabled = previous[index].disabled;
          button.removeAttribute('aria-busy');
        });
      });
    return modalLaunchPromise;
  }

  window.launchInstantBookModal = launchInstantBookModal;

  function bindInstantBookButton() {
    if (!$ || !$.fn || !$.fn.on) {
      return;
    }
    $('.iBook').on('click', function (e) {
      e.preventDefault();
      launchInstantBookModal();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInstantBookingSummary);
    document.addEventListener('DOMContentLoaded', ensureInstantBookDataAttributes);
  } else {
    initInstantBookingSummary();
    ensureInstantBookDataAttributes();
  }

  // PayPal loads inside paypal-checkout.js only after the customer chooses it.

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindInstantBookButton);
  } else {
    bindInstantBookButton();
  }

})(window, document, window.jQuery);
